<template>
  <v-container>
    <v-row class="pb-4">
      <v-col>
        <v-icon> mdi-bell-ring </v-icon>
        <span class="headline mx-2">Notifications</span>
      </v-col>
    </v-row>
    <v-row
      v-if="loading" 
      class="fill-height"
      
      align="center" 
      justify="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-row>
    <div v-else>
      <div 
        v-if="edit" 
      >
        <v-row
          v-for="(item,i) in employeeNotifications"
          :key="i"
        >
          <v-col
            cols="12"
            md="5" 
            xl="4"
            class="py-0"
          >
            <v-checkbox
              v-model="item.employee_notification_is_active"
              class="remove-gap"
            >
              <template v-slot:label>
                <div>
                  {{ item.name }}
                </div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
      </div> 
      <div v-else>
        <v-row
          v-for="(item,i) in employeeNotifications"
          :key="i"
        >
          <v-col
            cols="12"
            md="5" 
            xl="4"
          >
            <span class="font-weight-medium">{{ item.name }}</span>
          </v-col>
          <v-col>
            <v-icon 
              v-if="item.employee_notification_is_active === 1" 
              color="success"
            >
              mdi-check-circle
            </v-icon>
            <v-icon 
              v-else 
              color="error"
            >
              mdi-close-circle
            </v-icon>        
          </v-col>
        </v-row>
      </div>
    </div>

    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="!edit"
        color="info"
        @click="editForm"
      >
        Edit
      </v-btn>
      <div v-else>
        <v-btn
          :disabled="progressing"
          text
          @click="edit = false"
        >
          Cancel
        </v-btn>
        <v-btn          
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </div>
    </v-card-actions>
  </v-container>
</template>

<script>
  export default {
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        edit: false,
        employeeNotifications: [],
        notificationTypes: [],
        notifications: [],
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadData()
          }
        },
      },
    },
    methods: {    
      loadData () {
        Promise.all([
          this.$api.notificationTypes().list(),
          this.$api.employeeNotifications().list(this.employeeUid),
        ])
          .then(([notificationTypes, employeeNotifications]) => {
            this.notificationTypes = notificationTypes.data
            this.notifications = employeeNotifications.data
            notificationTypes.data.map(notificationType => {
              employeeNotifications.data.map(employeeNotification => {
                if (notificationType.id === employeeNotification.notification_type_id) {
                  notificationType.employee_notification_is_active = employeeNotification.is_active
                }
              })
           
              if (!notificationType.employee_notification_is_active) {
                notificationType.employee_notification_is_active = 0
              } 
            })

            this.employeeNotifications = notificationTypes.data
          })
      },

      submitForm () {
        this.progressing = true

        this.$api.employeeNotifications().update(this.employeeUid, this.prepareFormData())
          .then(response => {
            this.edit = false
            this.loadData()
            this.$snack({
              message: response.data.status,
            })
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
 
      editForm () {
        this.notificationTypes.map(notificationType => {
          this.notifications.map(employeeNotification => {
            if (notificationType.id === employeeNotification.notification_type_id) {
              notificationType.employee_notification_is_active = employeeNotification.is_active
            }
          })
           
          if (!notificationType.employee_notification_is_active) {
            notificationType.employee_notification_is_active = 0
          } 
        })

        this.employeeNotifications = this.notificationTypes

        this.edit = true
      },
      prepareFormData () {
        let data = []

        this.employeeNotifications.map(employeeNotification => {
          data.push({ notification_type: employeeNotification.id, is_active: employeeNotification.employee_notification_is_active })
        })
    
        return data
      },
    },
  }
</script>

<style scoped>
.remove-gap{
    padding-top:0px !important;
    margin-top:0px !important
}
</style>
